<template>
    <Header
        :elements="countElements"
        :current="currentElement"
    ></Header>
    <div class="MuiBox-root css-3d0ymh">
        <div class="MuiBox-root css-19vwmxk" data-testid="screen-business_details" tabindex="-1">
            <div class="MuiBox-root css-1n2tziu">
                <div class="MuiGrid-root MuiGrid-container css-15zova9 slide-up-enter-done" transition="250">
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-3 MuiGrid-grid-md-4 css-4lvwcn">
                        <div class="MuiBox-root css-1yu9eo3">
                            <div class="MuiGrid-root css-skpbsy">
                                <div class="MuiGrid-root css-vnk25j" type="lottie">
                                    <div>
                                        <Freezeframe
                                            src="/images/free-animated-icon-fast-forward-7740748.gif"
                                        ></Freezeframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-1 css-se8e58">
                        <div class="MuiBox-root css-8atqhb"></div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-7 css-xjtbym">
                        <div class="module-checkout">
                            <div class="checkDetail">
                                <h2> Do you have any proof to show you are using this trademark?
                                    <Popper>
                                        <span class="GetHelpItem">
                                            <span class="popover-icon">
                                                <i class="fa fa-question-circle" aria-hidden="true"></i>
                                            </span>
                                            Get Help
                                        </span>
                                        <template #content>
                                            <div class="popper-content">
                                                <b>What are the acceptable proof/specimen?</b>
                                                <p>A proof/specimen is a real-world example of how you are using your trademark on goods or in the offer of services. A specimen is more than just a picture of your trademark or logo. </p>
                                                <p><b>For Products</b>, acceptable specimens include product tags, packaging material, instruction manuals, and containers which display the trademark. Please note: brochures, business cards, catalogs and stationery are generally not acceptable specimens for products. </p>
                                                <p><b>For Services</b>, acceptable specimens include brochures, flyers, advertisements, yellow page listings and websites. Please note: for a business card to qualify as service trademark proof, the proposed trademark must be displayed on the card, along with the service offered in connection with it.</p>
                                                <b>Still need help?</b>
                                                <b>Call customer service at <span>1-833-863-5483</span></b>
                                            </div>
                                        </template>
                                    </Popper>
                                </h2>

                                <RadioCheckbox
                                    :value="is_have_proof_using"
                                    @change_c="is_have_proof_using = $event"
                                    type="radio"
                                    value_v="1"
                                    text="Yes"
                                    name="is_have_proof_using"
                                ></RadioCheckbox>
                                <RadioCheckbox
                                    :value="is_have_proof_using"
                                    @change_c="is_have_proof_using = $event"
                                    type="radio"
                                    value_v="0"
                                    text="No"
                                    name="is_have_proof_using"
                                ></RadioCheckbox>

                                <!-- upload doc -->
                                <div v-if="is_have_proof_using == 0" id="ans_1_0" class="ans_1 topSpace" style="">
                                    <p>No Problem. If you do not have any proof of using this trademark in commerce, we will move forward to <b>file a 6-month extension of time </b> to submit your statement of use.</p>
                                    <p>In U.S. Federal Trademark Registration, you will eventually need to submit proof of use in commerce and pay government fees in order to get your mark fully registered. </p>
                                </div>
                                <div v-else class="pt-d">
                                    <Proofs
                                        @update="update"
                                        :start_check="check"
                                        :start_proof_product="proof_product"
                                        :start_proof_product_package="proof_product_package"
                                        :start_proof_counter_display="proof_counter_display"
                                        :start_proof_website="proof_website"
                                        :start_proof_other="proof_other"
                                    ></Proofs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="css-1l6i970">
                <div class="css-1c73k7k">
                    <BottomButton
                        :active="true"
                        @click.native="back"
                        text="Back"
                        class_b="button-back"
                    ></BottomButton>
                    <BottomButton
                        :active="isContinue"
                        @click.native="next"
                        text="Next"
                        class_b="button-next"
                    ></BottomButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Freezeframe from '@/components/Freezeframe.vue'
import Header from '@/components/Header-Short-New.vue'
import BottomButton from '@/ui/Bottom-Button.vue'
import Proofs from '@/components/Proofs.vue'
import http from "@/api/http";
import RadioCheckbox from "@/ui/Radio-Checkbox";
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        Proofs,
        BottomButton,
        RadioCheckbox,
        Freezeframe
    },
    data() {
        return {
            is_have_proof_using: 0,
            check: '',
            proof_product: {
                description: '',
                src: '',
                file: '',
            },
            proof_product_package: {
                src: '',
                file: '',
            },
            proof_counter_display: {
                src: '',
                file: '',
            },
            proof_website: {
                description: '',
                src: '',
                file: '',
            },
            proof_other: {
                description: '',
                src: '',
                file: '',
            },
            classes: []
        }
    },
    mounted() {
        to_top()
        this.init()
    },
    methods: {
        async init(){
            let { data } = await http.get('statement-of-use/step-proof/' + this.$route.params.class + '/' + this.$route.params.key);

            if (data.res) {
                this.is_have_proof_using = data.data.data.is_have_proof_using
                this.proof_product = data.data.data.proof_product
                this.proof_product_package = data.data.data.proof_product_package
                this.proof_counter_display = data.data.data.proof_counter_display
                this.proof_website = data.data.data.proof_website
                this.proof_other = data.data.data.proof_other
                this.check = data.data.data.check
                this.classes = data.data.data.classes

                this.$store.commit('header/setTotal', data.data.data.total)
            }
        },
        async back(){
            this.$router.push({ path: '/statement-of-use/step-using/' + this.$route.params.class + '/' + this.$route.params.key })
        },
        async update(params){
            this.proof_product = params.proof_product
            this.proof_product_package = params.proof_product_package
            this.proof_counter_display = params.proof_counter_display
            this.proof_website = params.proof_website
            this.proof_other = params.proof_other
            this.check = params.check
        },
        async next(){
            const formData = new FormData()
            formData.append("is_have_proof_using", this.is_have_proof_using);
            formData.append("check", this.check);

            if (this.proof_product.file) {
                formData.append("proof_product_file", this.proof_product.file.file);
            }
            formData.append("proof_product_src", this.proof_product.src);
            formData.append("proof_product_description", this.proof_product.description);

            if (this.proof_product_package.file) {
                formData.append("proof_product_package_file", this.proof_product_package.file.file);
            }
            formData.append("proof_product_package_src", this.proof_product_package.src);

            if (this.proof_counter_display.file) {
                formData.append("proof_counter_display_file", this.proof_counter_display.file.file);
            }
            formData.append("proof_counter_display_src", this.proof_counter_display.src);

            if (this.proof_website.file) {
                formData.append("proof_website_file", this.proof_website.file.file);
            }
            formData.append("proof_website_src", this.proof_website.src);
            formData.append("proof_website_description", this.proof_website.description);

            if (this.proof_other.file) {
                formData.append("proof_other_file", this.proof_other.file.file);
            }
            formData.append("proof_other_src", this.proof_other.src);
            formData.append("proof_other_description", this.proof_other.description);

            let { data } = await http.post('statement-of-use/step-proof/'  + this.$route.params.class + '/' + this.$route.params.key, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            // console.log(1)
            // console.log(data)
            // console.log(data.res)
            if (data.res) {
                if (this.next_code) {
                    this.$router.push({ path: '/statement-of-use/step-using/' + this.next_code + '/' + this.$route.params.key })
                } else {
                    this.$router.push({ path: '/statement-of-use/step-end/' + this.$route.params.key })
                }
            }
        }
    },
    computed: {
        isContinue() {
            if (this.is_have_proof_using != 1) {
                return true
            }
            if (this.check == 'proof_product' && (this.proof_product.description || this.proof_product.file || this.proof_product.src)) {
                return true
            }
            if (this.check == 'proof_product_package' && (this.proof_product_package.file || this.proof_product_package.src)) {
                return true
            }
            if (this.check == 'proof_counter_display' && (this.proof_counter_display.file || this.proof_counter_display.src)) {
                return true
            }
            if (this.check == 'proof_website' && (this.proof_website.description || this.proof_website.file || this.proof_website.src)) {
                return true
            }
            if (this.check == 'proof_other' && (this.proof_other.description || this.proof_other.file || this.proof_other.src)) {
                return true
            }

            return false
        },
        next_code() {
            for (let i = 0; i < this.classes.length; i++) {
                if (this.classes[i].code == this.$route.params.class && typeof this.classes[i + 1] !== 'undefined') {
                    return this.classes[i + 1]['code']
                }
            }
        },
        countElements() {
            let num = 4

            for (let i = 0; i < this.classes.length; i++) {
                if (this.classes[i].is_using_trademark) {
                    num += 2
                } else {
                    num += 1
                }
            }

            return this.classes.length ? num + 2 : 0
        },
        currentElement() {
            let num = 4

            for (let i = 0; i < this.classes.length; i++) {
                if (this.classes[i].code == this.$route.params.class) {
                    num += 2
                    return num
                } else if (this.classes[i].is_using_trademark) {
                    num += 2
                } else {
                    num += 1
                }
            }

            return this.classes.length ? num : 0
        }
    }
}
</script>
